export const EMAILS = [
    'avancementchantier@admin.com'
]

